import { createAsyncThunk } from '@reduxjs/toolkit';

export const updateQrLabelCall = createAsyncThunk(
    'users/qrlabels/update',
    async (payload, thunkAPI,) => {

        const body = JSON.stringify(payload);
        const { id } = payload;

        try {
            const res = await fetch(`/api/users/qrlabels/update/${id}/`, {
                method: 'POST',
                headers: {
                    Accept: 'application/JSON',
                    'Content-Type': 'application/json'
                },
                body,
            });

            const data = await res.json();

            if (res.status === 200) {
                return data;

            } else {
                console.log("updateQrLabel != 200 -----------------------");
                return thunkAPI.rejectWithValue(data);
            }

        } catch (err) {
            console.log("updateQrLabel Error -----------------------");
            console.log(err);
            return thunkAPI.rejectWithValue(err.response.data);
        }
    }
);